module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessDelete(_vm.FUNCTIONALITY)) ? _c('div', [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Create new forecast window")]), _vm._v(" "), (_vm.forecast) ? _c('ForecastForm', {
    attrs: {
      "forecast": _vm.forecast,
      "brand-with-campaigns": _vm.brandWithCampaigns,
      "ref-date-is-equal-to-availability-date": _vm.refDateIsEqualToAvailabilityDate
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "buttons"
  }, [_c('ClientColorButton', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.createForecast
    }
  }, [_vm._v("Save Forecast")]), _vm._v(" \n        "), _c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.$router.push(("" + (_vm.ROUTES.BASE)))
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('br')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e692023","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastCreate.vue
// module id = 3172
// module chunks = 0